const baseUrl = process.env.REACT_APP_S3_BUCKET_BASE_URL;

export const prmedia_thermatru_product_flyer = 
{
    ref : 'prmedia_thermatru_product_flyer',
    area :'PR & Media Therma-Tru',

    title : 'Explore More Tools',
    info_default_view : false,
    info_navigation_view : true,
    navigationLevel : 2,
    navigation_box : '',
    parent : 'prmedia_thermatru',
    footerdiscription : true,

    ContentComponents: [

        {
            navigation_ref: 'door_system',
            type: 'navigation_box',
            title: 'Door System Brochure',
            footerdiscription : true,
            discription : 'Product Flyers',

            buttonList: [
                {
                    title: 'Advanta Lite Frame Flyer',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_product_flyer_advanta_lite_frame'
                },
                {
                    title: 'Craftsman Shaker-Style Entry Door Options Flyer',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_product_flyer_craftsman_shaker'

                },
                {
                    title: 'Impressions Integrated Storm and Entry System Flyer',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_product_flyer_storm_entry_system'

                },
                {
                    title: 'New Glass Designs Flyer',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_product_flyer_glass_design'

                },
                {
                    title: 'Alpine Color-Matched Lite Frames & Simulated Divided Lite Bars Flyer',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_product_flyer_alpine_lite_fram_bars'

                },
                {
                    title: 'Veris Flyer',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_product_flyer_veris_flyer'

                },

                // {
                //     title: `8'0"" Smooth-Star Flush-Glazed Doors with Elevated Bottom Rail 2`,
                //     type : 'navigationbuttonlist',
                //     contentKey : 'prmedia_thermatru_product_flyer_smoother2'

                // },

                // {
                //     title: `8'0"" Smooth-Star Flush-Glazed Doors with Elevated Bottom Rail 3`,
                //     type : 'navigationbuttonlist',
                //     contentKey : 'prmedia_thermatru_product_flyer_smoother3'

                // },

                // {
                //     title: `8'0"" Smooth-Star Flush-Glazed Doors with Elevated Bottom Rail 4`,
                //     type : 'navigationbuttonlist',
                //     contentKey : 'prmedia_thermatru_product_flyer_smoother4'

                // },

                // {
                //     title: `8'0"" Smooth-Star Flush-Glazed Doors with Elevated Bottom Rail 5`,
                //     type : 'navigationbuttonlist',
                //     contentKey : 'prmedia_thermatru_product_flyer_smoother5'

                // },
            ]
        },

    ],
    navigationComponents: [
        // { key : 'door_system' , name: 'Door System Brochure'},

    ],


}

export const prmedia_thermatru_product_flyer_classic_craft = {
    ref : 'prmedia_thermatru_product_flyer_advanta_lite_frame',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Flyer_Advanta_HO-Dealer.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_product_flyer',
    area :'PR & Media Therma-Tru',
    title: 'Advanta Lite Frame Flyer',

}


export const prmedia_thermatru_product_flyer_impression = {
    ref : 'prmedia_thermatru_product_flyer_craftsman_shaker',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Flyer_HOMCraftsmanShakerExpansion.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_product_flyer',
    area :'PR & Media Therma-Tru',
    title: 'Craftsman Shaker-Style Entry Door Options Flyer',

}


export const prmedia_thermatru_product_flyer_retractable = {
    ref : 'prmedia_thermatru_product_flyer_storm_entry_system',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Flyer_Impressions_Phase2.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_product_flyer',
    area :'PR & Media Therma-Tru',
    title: 'Impressions Integrated Storm and Entry System Flyer',

}




export const prmedia_thermatru_product_flyer_shaker = {
    ref : 'prmedia_thermatru_product_flyer_glass_design',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Flyer_HOMDecoGlass.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_product_flyer',
    area :'PR & Media Therma-Tru',
    title : 'New Glass Designs Flyer'
}



export const prmedia_thermatru_product_flyer_smoother = {
    ref : 'prmedia_thermatru_product_flyer_alpine_lite_fram_bars',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Flyer_AlpineColorMatched-LiteFramesSDLs.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_product_flyer',
    area :'PR & Media Therma-Tru',
    title: 'Alpine Color-Matched Lite Frames & Simulated Divided Lite Bars Flyer',

}


export const prmedia_thermatru_product_flyer_smoother1 = {
    ref : 'prmedia_thermatru_product_flyer_veris_flyer',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Veris.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_product_flyer',
    area :'PR & Media Therma-Tru',
    title: 'Veris Flyer',

}


export const prmedia_thermatru_product_flyer_smoother2 = {
    ref : 'prmedia_thermatru_product_flyer_smoother2',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/TT PR & Media Flyers Placeholder.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_product_flyer',
    area :'PR & Media Therma-Tru',
    title: `8'0"" Smooth-Star Flush-Glazed Doors with Elevated Bottom Rail 2`,

}




export const prmedia_thermatru_product_flyer_smoother3 = {
    ref : 'prmedia_thermatru_product_flyer_smoother3',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/TT PR & Media Flyers Placeholder.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_product_flyer',
    area :'PR & Media Therma-Tru',
    title: `8'0"" Smooth-Star Flush-Glazed Doors with Elevated Bottom Rail 3`,

}


export const prmedia_thermatru_product_flyer_smoother4 = {
    ref : 'prmedia_thermatru_product_flyer_smoother4',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/TT PR & Media Flyers Placeholder.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_product_flyer',
    area :'PR & Media Therma-Tru',
    title: `8'0"" Smooth-Star Flush-Glazed Doors with Elevated Bottom Rail 4`,

}



export const prmedia_thermatru_product_flyer_smoother5 = {
    ref : 'prmedia_thermatru_product_flyer_smoother5',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/TT PR & Media Flyers Placeholder.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_product_flyer',
    area :'PR & Media Therma-Tru',
    title: `8'0"" Smooth-Star Flush-Glazed Doors with Elevated Bottom Rail 5`,

}
